import { useDialog } from '@/common/dialog/DialogContext';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { EntityUtils } from '@/common/utils/EntityUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useCallback, useRef } from 'react';
import { PolForumlaExprDialog } from './PolFormulaExprDialog';

export const PolFormulaList = ({ polId }) => {
  const rsrc = useRsrc();
  const { hasRole } = usePrincipal();
  const { openDialog } = useDialog();
  const polFormulaListRef = useRef();

  // Outline Toggle
  const [isOutline, setIsOutline] = useNavStateSync('polFormulaIsOutlineOn', false);

  // If Outline, set code to autoGrouping
  const augFieldDefs = (fieldToFieldDef) => {
    if (isOutline) {
      fieldToFieldDef.code.autoGrouping = true;
    }

    fieldToFieldDef.verStartInstant.sort = null;
    fieldToFieldDef.id.sort = 'asc';
  };

  // Flat Mode
  const augRowsReq = useCallback(EntityUtils.parentFilterAugRowsReq('POL', polId), [polId]);

  // Outline Mode
  const clientSideRowData = useCallback((setDataSource) => {
    const reqParam = {
      polId,
      polIds: [polId],
    };

    rsrc.data('gp', 'POL_FORMULA_DATA_PLUGIN', reqParam).then((res) => {
      setDataSource(res);
    });
  }, []);

  const openPolFormulaExprDialog = (rowData) => {
    const data = {
      name: rowData.name,
      code: rowData.code,
      polId: rowData.polId,
      module: 'gp',
    };
    openDialog(PolForumlaExprDialog, { data });
  };

  const getContextMenuItems = (params) => {
    let contextMenus = polFormulaListRef.current.getContextMenuItems(params);

    const formulaName = 'Formula Expression';
    const polFormulaApplicable = !['FACTOR', 'REF', 'INFO'].includes(params.node.data.type);
    const hasPolFormulaView = hasRole('GP_POL_FORMULA_VIEW');
    if (polFormulaApplicable && hasPolFormulaView) {
      contextMenus.splice(1, 0, {
        name: formulaName,
        icon: fas.faInfoCircle,
        action: () => openPolFormulaExprDialog(params.node.data),
      });
    }
    return contextMenus;
  };

  const augTabButtons = (buttons) => {
    buttons.push(
      <ToggleButtonGroup
        value={isOutline ? 'outline' : 'flat'}
        exclusive
        onChange={(e, value) => {
          setIsOutline(value === 'outline');
        }}
        sx={{ height: 40, color: 'primary.main' }}
      >
        <ToggleButton value="outline" sx={{ whiteSpace: 'nowrap' }}>
          Outline
        </ToggleButton>
        <ToggleButton value="flat" sx={{ whiteSpace: 'nowrap' }}>
          Flat
        </ToggleButton>
      </ToggleButtonGroup>,
    );

    buttons.reverse();
  };

  return (
    <EntityList
      ref={polFormulaListRef}
      key={isOutline} // React will completely reinitialize the component any time the key changes
      entity="POL_FORMULA"
      augRowsReq={augRowsReq}
      augFieldDefs={augFieldDefs}
      sortModel={[{ colId: 'id', sort: 'asc' }]}
      clientSideRowData={isOutline ? clientSideRowData : null}
      augTabButtons={augTabButtons}
      gridOptions={{
        treeData: isOutline,
        getContextMenuItems,
      }}
    />
  );
};
